import { render, staticRenderFns } from "./Mapa.vue?vue&type=template&id=3c13a4e4&scoped=true"
import script from "./Mapa.vue?vue&type=script&lang=js"
export * from "./Mapa.vue?vue&type=script&lang=js"
import style0 from "./Mapa.vue?vue&type=style&index=0&id=3c13a4e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c13a4e4",
  null
  
)

export default component.exports